
console.log("config")
console.log("NODE_ENV=" + process.env.NODE_ENV)
console.log("VUE_APP_FLAG=" + process.env.VUE_APP_FLAG)
var config = {

}

var protocolStr = document.location.protocol;
var ws = "ws:"
if (protocolStr == "https:") {
    ws = "wss:"
}
if (process.env.VUE_APP_FLAG == "production") {
        // config.ws = ws + '//129.204.102.39:5004/ws'
    config.ws = 'ws://47.114.153.117:8006/websocket'
    config.baseURL =  "http://47.114.153.117:8006" //
    config.alioss = {
        accessKeyId: 'LTAIU6BMqvi6KArB',
        accessKeySecret: 'Gu5fVBiVQpJYzCQRjsU7cNCYpRSDeA',
        bucket: 'xsousou-production',
        region: 'oss-cn-beijing',
        endpoint: "oss-cn-beijing.aliyuncs.com"
    }
    config.txcos = {
        wxdownurl:'xsousou-1257149694.picbj.myqcloud.com',
        accessKeyId: 'AKIDvlQuSSB6iJr7Pw8p2AaBex9EBTjqwDXp',
        accessKeySecret: '31p1HRg5oekiK5PfsxraAZs0BSwKcxHU',
        bucket: 'xsousou-1257149694',
        region: 'ap-beijing',
        // endpoint: "oss-cn-shanghai.aliyuncs.com"
    }
} else if (process.env.VUE_APP_FLAG == "testing") {
    config.ws = 'ws://47.114.153.117:8006/websocket'
    config.baseURL =  "http://47.114.153.117:8006" //
        config.txcos = {
            wxdownurl:'xsousoudev-1257149694.picbj.myqcloud.com',
            accessKeyId: 'AKIDvlQuSSB6iJr7Pw8p2AaBex9EBTjqwDXp',
            accessKeySecret: '31p1HRg5oekiK5PfsxraAZs0BSwKcxHU',
            bucket: 'xsousoudev-1257149694',
            region: 'ap-beijing',
            // endpoint: "oss-cn-shanghai.aliyuncs.com"
        }       
} 

if (process.env.NODE_ENV == "development") {
    config.ws = 'ws://39.105.194.73:6006/websocket'
    config.baseURL = "http://39.105.194.73:6006" //
    config.txcos = {
        wxdownurl:'xsousoudev-1257149694.picbj.myqcloud.com',
        accessKeyId: 'AKIDvlQuSSB6iJr7Pw8p2AaBex9EBTjqwDXp',
        accessKeySecret: '31p1HRg5oekiK5PfsxraAZs0BSwKcxHU',
        bucket: 'xsousoudev-1257149694',
        region: 'ap-beijing',
        // endpoint: "oss-cn-shanghai.aliyuncs.com"
    }
}




export default config